
import useAppContext from '@/useAppContext'

export const checkZFyewuPermission = () => {
  const { context } = useAppContext.getContext()
  const { user } = context
  const { codes = [] } = user || {}

  return !codes.some((c) => c.includes('zf'))
}

// export const withPermission = (Component: React.ComponentType, checkZFyewuPermission: () => boolean) => {
//   return (props: any) => {
//     if (permissionCheck()) {
//       return <Component {...props} />
//     }
//     return <Navigate to="/" replace />
//   }
// }
